// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../../../index.mjs";
export const LicenseConfig = {
    basic: (value) => {
        return Object.assign(Object.assign({}, value), { type: "basic", _visit: function (visitor) {
                return FernIr.generatorExec.LicenseConfig._visit(this, visitor);
            } });
    },
    custom: (value) => {
        return Object.assign(Object.assign({}, value), { type: "custom", _visit: function (visitor) {
                return FernIr.generatorExec.LicenseConfig._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "basic":
                return visitor.basic(value);
            case "custom":
                return visitor.custom(value);
            default:
                return visitor._other(value);
        }
    },
};
